import { useQuery } from '@tanstack/react-query';
import { posService } from '@/services/pos.service';

/** Setting hiếm khi đổi (chỉ đổi khi admin sửa nhóm ngành thuế/danh mục dịch
 *  vụ) — cache 5 phút như `useGeneralConfig`, tránh POS refetch liên tục. */
const STALE_TIME_MS = 5 * 60_000;

export function usePosServiceEffectiveVat() {
  return useQuery({
    queryKey: ['pos', 'services', 'effective-vat'],
    queryFn: () => posService.getServiceEffectiveVat(),
    staleTime: STALE_TIME_MS,
    retry: 2,
  });
}
